import { CheckCircle, AlertCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function ActionPopup({ open, type, message, onClose }) {
  const config = {
    success: {
      icon: <CheckCircle className="text-success" size={48} />,
      btn: "bg-success hover:bg-success/90 text-success-foreground",
    },
    error: {
      icon: <XCircle className="text-destructive" size={48} />,
      btn: "bg-destructive hover:bg-destructive/90 text-destructive-foreground",
    },
    warning: {
      icon: <AlertCircle className="text-accent" size={48} />,
      btn: "bg-accent hover:bg-accent/90 text-accent-foreground",
    },
  };

  const selected = config[type] || config.success;

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent className="max-w-xs p-6 text-center rounded-2xl">

        <div className="flex justify-center mb-4">
          {selected.icon}
        </div>

        <p className="text-foreground font-medium mb-6">
          {message}
        </p>

        <Button
          onClick={onClose}
          className={`px-6 py-2 rounded-lg transition ${selected.btn}`}
        >
          OK
        </Button>

      </DialogContent>
    </Dialog>
  );
}
